import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

import { withTextSanitization } from './withTextSanitization'

export const TEXT_SANITIZATION_PLUGIN_KEY = 'text-sanitization-plugin'

export const createTextSanitizationPlugin = (): AnyPlatePlugin => {
  // Not returned directly from the arrow function: an explicit return type
  // on the expression itself back-propagates into createPlatePlugin's own
  // generic inference and corrupts it (options/node end up typed against
  // the annotation's defaults instead of the literal passed in).
  const plugin = createPlatePlugin({
    key: TEXT_SANITIZATION_PLUGIN_KEY,
    extendEditor: ({ editor }) =>
      withTextSanitization(editor as unknown as BufferEditor),
  })
  return plugin
}
